// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vsk: CountryValidator<"IS"> = createValidator(
  "is.vsk",
  103,
);

export default vsk;
export const compact = vsk.compact;
export const format = vsk.format;
export const validate = vsk.validate;
export const generate = (): string =>
  vsk.generate?.() ??
  (() => {
    throw new Error(
      "Validator is.vsk cannot generate values",
    );
  })();
